<template>
  <RevCard v-if="flashSalesDiscount" class="p-24">
    <p class="body-1">{{ i18n(translations.title) }}</p>
    <div class="mt-16 flex flex-col md:flex-row md:items-stretch">
      <div
        class="bg-static-success-low rounded-sm body-1 flex w-full items-center justify-between p-12"
      >
        <p class="flex items-center">
          <IconCheckInCircle class="mr-16" />
          {{ i18n(translations.flashDeal) }}
        </p>
        <p>-{{ i18n.price(flashSalesDiscount) }}</p>
      </div>
      <RevButton
        class="mt-16 md:ml-24 md:mt-0"
        :disabled="isLoading"
        variant="secondaryDestructive"
        @click="handleRemove"
        >{{ i18n(translations.removeDiscount) }}</RevButton
      >
    </div>

    <p class="text-static-default-low body-2 mt-8">
      {{ i18n(translations.warning) }}
    </p>
  </RevCard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'

import {
  getEligiblePromoCode,
  getFlashSalesDiscount,
} from '../../utils/flash-sales'

import translations from './FlashSalesDiscountCard.translations'

const props = defineProps<{ items: Array<CartItem> }>()
const emit = defineEmits(['removed'])

const flashSalesDiscount = computed(() => getFlashSalesDiscount(props.items))

const i18n = useI18n()
const $httpFetch = useHttpFetch()
const isLoading = ref(false)
const handleRemove = async () => {
  const promoCode = getEligiblePromoCode(props.items)
  if (!promoCode) return

  try {
    isLoading.value = true
    await $httpFetch('/bm/cart/services', {
      method: 'DELETE',
      body: {
        type: 'PROMO_CODE',
        promoCodeToken: promoCode.token,
      },
    })
    emit('removed')
  } catch {
    // Fails silently
  } finally {
    isLoading.value = false
  }
}
</script>
